module.exports = __webpack_public_path__ + "img/1531931391.ab962cbd.jpg";